<template>
<div class="chapter">
<div class="inner_page">
<p class="center"><strong>Praise for <em>Eifelheim</em></strong></p>
<p class="center"><strong><span class="small">A HUGO AWARD FINALIST</span></strong><br/><strong>Chosen as one of <em>Kirkus Review’s</em></strong><br/><strong>Best Books of 2006</strong></p>
<div class="block">
<p class="nonindent">“Bursting with pungent historical detail and big theme musings, this dense, provocative novel offers big rewards to patient readers.”</p>
<p class="right">—<em>Entertainment Weekly</em></p>
</div>
<div class="block">
<p class="nonindent">“Flynn’s combination of science fiction, historical fact, and logical deduction makes for a fascinating and addictive read.”</p>
<p class="right">—<em>Rocky Mountain News</em></p>
</div>
<div class="block">
<p class="nonindent">“With a sure grasp of both speculative science and medieval history, Flynn compellingly weaves past and present together in a dialog of faith and science. With neat turns of plot and intriguing medieval and modern characters … Highly recommended.”</p>
<p class="right"><em>—Library Journal</em> (starred review)</p>
</div>
<div class="block">
<p class="nonindent">“Heartbreaking … Flynn masterfully achieves an intricate panorama of medieval life, full of fascinatingly realized human and Krenken characters whose fates interconnect with poignant irony.”</p>
<p class="right"><em>—Publishers Weekly</em> (starred review)</p>
</div>
<div class="block">
<p class="nonindent">“Meticulously researched, intense, mesmerizing novel (based in some part on a 1986 short story) for readers seeking thoughtful science fiction of the highest order.”</p>
<p class="right"><em>—Kirkus Reviews</em> (starred review)</p>
</div>
<div class="block">
<p class="nonindent">“An arresting revision of many contemporary assumptions about human nature … As usual, Flynn’s content and form render his work both engaging and engrossing.”</p>
<p class="right">—<em>SFRA Review</em></p>
</div>
<div class="block">
<p class="nonindent">“In Flynn’s masterful hand, even the most fateful conversations take delightful turns as human and alien discuss the heavens and how to return to them. <em>Eifelheim</em> is both speculative fiction and morality tale.”</p>
<p class="right"><em>—Sunday Free Press</em></p>
</div>
<div class="block">
<p class="nonindent">“[Flynn] makes both—the medieval German town and the modern couple trying to determine the likelihood of interstellar travel—real, physical, and emotional…. A remarkably rich and dense work.”</p>
<p class="right"><em>—Bookgasm</em></p>
</div>
<div class="block">
<p class="nonindent">“Wonderful, mesmerizing. A finely written and deeply considered SF novel that deserves to stand with the classics in the field. It reads like Arthur C. Clarke channeling Einstein channeling Thomas Aquinas—and that’s only the beginning. This book should be garlanded with awards, but more important, it should be in your hands, and you should be reading it.”</p>
<p class="right">—Robert Charles Wilson</p>
</div>
<div class="block">
<p class="nonindent">“Michael Flynn’s <em>Eifelheim</em> is a gripping multilayered masterpiece that pulls off the extraordinary feat of imagining a convincing first contact with aliens that might have taken place in 1348.”</p>
<p class="right">—Brian Stableford</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780765340351_epub_col_r1.vue?252ecccc